module.exports = __webpack_public_path__ + "static/media/al.89fa1ce3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/al.svg
// module id = 47
// module chunks = 0